import { AuthService } from './../serv/auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  constructor(public auth : AuthService) { }

  loginGo(){
    this.auth.loginwithgoogle();
  };
  loginFc(){
    this.auth.loginwithfacebook();
  };

  ngOnInit(): void {
  }

}
